// ISO 3166-1 alpha-3 → Italian country name
// Curated list used for citizenship + birth-country combos.
// Italy first so it's the most prominent suggestion.
export const COUNTRIES = [
  { code: "ITA", name: "Italia" },
  { code: "ALB", name: "Albania" },
  { code: "DZA", name: "Algeria" },
  { code: "AND", name: "Andorra" },
  { code: "AGO", name: "Angola" },
  { code: "ARG", name: "Argentina" },
  { code: "ARM", name: "Armenia" },
  { code: "AUS", name: "Australia" },
  { code: "AUT", name: "Austria" },
  { code: "AZE", name: "Azerbaigian" },
  { code: "BHR", name: "Bahrein" },
  { code: "BGD", name: "Bangladesh" },
  { code: "BEL", name: "Belgio" },
  { code: "BLZ", name: "Belize" },
  { code: "BEN", name: "Benin" },
  { code: "BLR", name: "Bielorussia" },
  { code: "BOL", name: "Bolivia" },
  { code: "BIH", name: "Bosnia ed Erzegovina" },
  { code: "BWA", name: "Botswana" },
  { code: "BRA", name: "Brasile" },
  { code: "BRN", name: "Brunei" },
  { code: "BGR", name: "Bulgaria" },
  { code: "BFA", name: "Burkina Faso" },
  { code: "BDI", name: "Burundi" },
  { code: "BTN", name: "Bhutan" },
  { code: "KHM", name: "Cambogia" },
  { code: "CMR", name: "Camerun" },
  { code: "CAN", name: "Canada" },
  { code: "CPV", name: "Capo Verde" },
  { code: "TCD", name: "Ciad" },
  { code: "CHL", name: "Cile" },
  { code: "CHN", name: "Cina" },
  { code: "CYP", name: "Cipro" },
  { code: "COL", name: "Colombia" },
  { code: "COG", name: "Congo" },
  { code: "COD", name: "Congo (Rep. Dem.)" },
  { code: "KOR", name: "Corea del Sud" },
  { code: "PRK", name: "Corea del Nord" },
  { code: "CIV", name: "Costa d'Avorio" },
  { code: "CRI", name: "Costa Rica" },
  { code: "HRV", name: "Croazia" },
  { code: "CUB", name: "Cuba" },
  { code: "DNK", name: "Danimarca" },
  { code: "DMA", name: "Dominica" },
  { code: "DOM", name: "Repubblica Dominicana" },
  { code: "ECU", name: "Ecuador" },
  { code: "EGY", name: "Egitto" },
  { code: "SLV", name: "El Salvador" },
  { code: "ARE", name: "Emirati Arabi Uniti" },
  { code: "ERI", name: "Eritrea" },
  { code: "EST", name: "Estonia" },
  { code: "ETH", name: "Etiopia" },
  { code: "FJI", name: "Figi" },
  { code: "PHL", name: "Filippine" },
  { code: "FIN", name: "Finlandia" },
  { code: "FRA", name: "Francia" },
  { code: "GAB", name: "Gabon" },
  { code: "GMB", name: "Gambia" },
  { code: "GEO", name: "Georgia" },
  { code: "DEU", name: "Germania" },
  { code: "GHA", name: "Ghana" },
  { code: "JAM", name: "Giamaica" },
  { code: "JPN", name: "Giappone" },
  { code: "JOR", name: "Giordania" },
  { code: "GRC", name: "Grecia" },
  { code: "GRD", name: "Grenada" },
  { code: "GTM", name: "Guatemala" },
  { code: "GIN", name: "Guinea" },
  { code: "GNB", name: "Guinea-Bissau" },
  { code: "GNQ", name: "Guinea Equatoriale" },
  { code: "GUY", name: "Guyana" },
  { code: "HTI", name: "Haiti" },
  { code: "HND", name: "Honduras" },
  { code: "IND", name: "India" },
  { code: "IDN", name: "Indonesia" },
  { code: "IRN", name: "Iran" },
  { code: "IRQ", name: "Iraq" },
  { code: "IRL", name: "Irlanda" },
  { code: "ISL", name: "Islanda" },
  { code: "ISR", name: "Israele" },
  { code: "KAZ", name: "Kazakistan" },
  { code: "KEN", name: "Kenya" },
  { code: "KGZ", name: "Kirghizistan" },
  { code: "XKX", name: "Kosovo" },
  { code: "KWT", name: "Kuwait" },
  { code: "LAO", name: "Laos" },
  { code: "LSO", name: "Lesotho" },
  { code: "LVA", name: "Lettonia" },
  { code: "LBN", name: "Libano" },
  { code: "LBR", name: "Liberia" },
  { code: "LBY", name: "Libia" },
  { code: "LIE", name: "Liechtenstein" },
  { code: "LTU", name: "Lituania" },
  { code: "LUX", name: "Lussemburgo" },
  { code: "MKD", name: "Macedonia del Nord" },
  { code: "MDG", name: "Madagascar" },
  { code: "MWI", name: "Malawi" },
  { code: "MYS", name: "Malesia" },
  { code: "MDV", name: "Maldive" },
  { code: "MLI", name: "Mali" },
  { code: "MLT", name: "Malta" },
  { code: "MAR", name: "Marocco" },
  { code: "MRT", name: "Mauritania" },
  { code: "MUS", name: "Mauritius" },
  { code: "MEX", name: "Messico" },
  { code: "MDA", name: "Moldavia" },
  { code: "MCO", name: "Monaco" },
  { code: "MNG", name: "Mongolia" },
  { code: "MNE", name: "Montenegro" },
  { code: "MOZ", name: "Mozambico" },
  { code: "MMR", name: "Myanmar (Birmania)" },
  { code: "NAM", name: "Namibia" },
  { code: "NPL", name: "Nepal" },
  { code: "NIC", name: "Nicaragua" },
  { code: "NER", name: "Niger" },
  { code: "NGA", name: "Nigeria" },
  { code: "NOR", name: "Norvegia" },
  { code: "NZL", name: "Nuova Zelanda" },
  { code: "OMN", name: "Oman" },
  { code: "NLD", name: "Paesi Bassi" },
  { code: "PAK", name: "Pakistan" },
  { code: "PAN", name: "Panama" },
  { code: "PNG", name: "Papua Nuova Guinea" },
  { code: "PRY", name: "Paraguay" },
  { code: "PER", name: "Perù" },
  { code: "POL", name: "Polonia" },
  { code: "PRT", name: "Portogallo" },
  { code: "QAT", name: "Qatar" },
  { code: "GBR", name: "Regno Unito" },
  { code: "CZE", name: "Repubblica Ceca" },
  { code: "CAF", name: "Repubblica Centrafricana" },
  { code: "ROU", name: "Romania" },
  { code: "RWA", name: "Ruanda" },
  { code: "RUS", name: "Russia" },
  { code: "SMR", name: "San Marino" },
  { code: "VCT", name: "Saint Vincent e Grenadine" },
  { code: "STP", name: "São Tomé e Príncipe" },
  { code: "SEN", name: "Senegal" },
  { code: "SRB", name: "Serbia" },
  { code: "SYC", name: "Seychelles" },
  { code: "SLE", name: "Sierra Leone" },
  { code: "SGP", name: "Singapore" },
  { code: "SYR", name: "Siria" },
  { code: "SVK", name: "Slovacchia" },
  { code: "SVN", name: "Slovenia" },
  { code: "SOM", name: "Somalia" },
  { code: "ESP", name: "Spagna" },
  { code: "LKA", name: "Sri Lanka" },
  { code: "USA", name: "Stati Uniti d'America" },
  { code: "ZAF", name: "Sudafrica" },
  { code: "SDN", name: "Sudan" },
  { code: "SSD", name: "Sud Sudan" },
  { code: "SWE", name: "Svezia" },
  { code: "CHE", name: "Svizzera" },
  { code: "SWZ", name: "Eswatini (Swaziland)" },
  { code: "TJK", name: "Tagikistan" },
  { code: "TWN", name: "Taiwan" },
  { code: "TZA", name: "Tanzania" },
  { code: "THA", name: "Thailandia" },
  { code: "TLS", name: "Timor Est" },
  { code: "TGO", name: "Togo" },
  { code: "TON", name: "Tonga" },
  { code: "TTO", name: "Trinidad e Tobago" },
  { code: "TUN", name: "Tunisia" },
  { code: "TUR", name: "Turchia" },
  { code: "TKM", name: "Turkmenistan" },
  { code: "UKR", name: "Ucraina" },
  { code: "UGA", name: "Uganda" },
  { code: "HUN", name: "Ungheria" },
  { code: "URY", name: "Uruguay" },
  { code: "UZB", name: "Uzbekistan" },
  { code: "VUT", name: "Vanuatu" },
  { code: "VAT", name: "Città del Vaticano" },
  { code: "VEN", name: "Venezuela" },
  { code: "VNM", name: "Vietnam" },
  { code: "YEM", name: "Yemen" },
  { code: "ZMB", name: "Zambia" },
  { code: "ZWE", name: "Zimbabwe" },
];

// Quick lookup by ISO3 → Italian name
export const COUNTRY_NAME = COUNTRIES.reduce((acc, c) => {
  acc[c.code] = c.name;
  return acc;
}, {});

// Reverse lookup by lowercased Italian name → ISO3
export const COUNTRY_CODE_BY_NAME = COUNTRIES.reduce((acc, c) => {
  acc[c.name.toLowerCase()] = c.code;
  return acc;
}, {});
